import { PatientConsentBaseViewModel } from "./PatientConsentBaseViewModel";
import { SetupCompletionView } from "./AccountSetupCompletionView";
export class PatientConsentSetupCompletionViewModel extends PatientConsentBaseViewModel {
    constructor(container) {
        super(container);
        this.patientConsentUIManager = container.patientConsentUIManager;
        this.accountSetupCompletionManager = container.accountSetupCompletionManager;
        this.socialLoginAuthManager = container.socialLoginAuthManager;
        this.verifyOTPManager = container.verifyOTPManager;
        this.accountSetupCompletionManager.prepopulate(this.patientConsentUIManager.consentingPatientInfo);
    }
    get formModel() {
        return this.accountSetupCompletionManager.formModel;
    }
    get hasAgeValidationError() {
        return this.accountSetupCompletionManager.hasAgeValidationError;
    }
    get viewToDisplay() {
        return this.accountSetupCompletionManager.shouldShowPhoneOnlyScreen ? SetupCompletionView.PHONE_ONLY : SetupCompletionView.FULL_FORM;
    }
    async continue() {
        var _a;
        if (!this.accountSetupCompletionManager.validateInput())
            return;
        const pendingVerificationKey = (_a = this.socialLoginAuthManager.pendingSocialLoginData) === null || _a === void 0 ? void 0 : _a.verificationKey;
        const { input } = this.accountSetupCompletionManager;
        if (pendingVerificationKey) {
            this.verifyOTPManager.pendingVerificationKey = pendingVerificationKey;
            this.verifyOTPManager.pendingVerificationPhone = input.mobilePhone;
            const nextPage = this.patientConsentUIManager.getNextPageRoute();
            if (nextPage) {
                this.patientConsentUIManager.goToPage(nextPage);
                await this.verifyOTPManager.sendVerificationCode(true);
            }
            else {
                console.error("No next page found while going to next page");
            }
        }
    }
}
